import gql from 'graphql-tag';

export const CREATE_TRANSPORTS = gql`
  mutation createManyLocalLogisticOptions(
    $input: [CreateLocalLogisticOptionInput]
  ) {
    createManyLocalLogisticOptions(input: $input) {
      comment
      cost
      costCurrency
      costVolume
      firstValidityDate
      lastValidityDate
      destinationArea
      logisticForwarder
      logisticMaterial
      mode
      preCarriageArea
      preCarriageLine
      qualityGroup
    }
  }
`;
